import { Errors } from './errorMessages';

export function getErrorMessage(errorCode: string) {
  switch (errorCode) {
    case Errors.CREDIT_CARD_NOT_UNIQUE:
      return 'This credit card is already added. Please try another credit card.';
    case Errors.ADDRESS_NOT_VALID:
      return 'Please enter a valid address';
    case Errors.FORBIDDEN:
      return 'This is forbidden, please contact customer support';
    case Errors.PAYMENT_ERROR:
      return 'There was an error processing your card.';
    default:
      return 'An error occurred. Please try again.';
  }
}
